<template>
	<span :class="classes">
    <slot></slot>
  </span>
</template>

<script>

  const prefix = 'e-badge';

	export default {
		name: "e-badge",
    props: {
		  color: {
		    type: String,
        default: 'white'
      }
    },
    computed: {
		  classes() {
		    return [
		      prefix,
          `${prefix}-color-${this.color}`
        ]
      }
    }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/badge/badge.vue